export const PHOTO_CONFIG = {
  requiredCoins: 3,
  historyRetentionDays: 7,
  ngrokSkipBrowserWarning: '69420',
};

export const PHOTO_WEBHOOKS = {
  userInfo: 'https://bshong-n8n.ngrok.io/webhook/user_info',
  imageHistory: 'https://bshong-n8n.ngrok.io/webhook/photo/get-image',
  customerSupport: 'https://bshong-n8n.ngrok.io/webhook/photo-cs',
  deleteImage: 'https://bshong-n8n.ngrok.io/webhook/photo/delete-image',
};


